<template>
    <div class="container _container">
      <div class="containerbody">
        <div class="content">
          <div class="content_left">
            <el-card>
              <div class="sideBar">
                <div class="head_title">{{ titleData.title }}</div>
                <!-- <div >
                    <div class="sub_title">CRIME&nbsp;INVETIGATION</div>
                    <div class="sub_title">ASSISANCE</div>
                </div> -->
                <div class="divide_line"></div>
                <div v-for="(item,index) in titleData.children" :key="index" class="head_title_ch"
                     :class="index == activeIndex?'navActive':'nav'" @click="subTitleClick(index,item)">{{ item.title }}
                </div>


              </div>
            </el-card>
          </div>
          <div class="content_right">
            <el-card>
              <div slot="header" class="text_title _text_title">
                <span>{{ titleDataChild[activeIndex].title }}</span>
              </div>
              
              <!-- Advanced Search Area -->
              <div class="advanced-search">
                <div class="search-form">
                  <el-input
                    v-model="queryParams.title"
                    :placeholder="$t('home.placeholder') || 'Enter keyword'"
                    class="search-input">
                  </el-input>
                  <el-date-picker
                    v-model="queryParams.startTime"
                    type="date"
                    :placeholder="$t('home.startDate') || 'Start date'"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    class="date-picker">
                  </el-date-picker>
                  <el-date-picker
                    v-model="queryParams.endTime"
                    type="date"
                    :placeholder="$t('home.endDate') || 'End date'"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    class="date-picker">
                  </el-date-picker>
                  <el-button type="primary" @click="handleSearch" class="search-button">
                    {{ $t('home.search') || 'SEARCH' }}
                  </el-button>
                </div>
              </div>
              
              <div class="media-grid">
                <div v-for="(item,index) in contentList" :key="index" class="media-item" @click="openDetail(item)">
                  <div class="media-image" :style="{ backgroundImage: `url(${$urlFile+item.Img})` }">
                    <div v-if="queryParamsForm.mediaType === 'video'" class="play-icon">
                      <i class="el-icon-video-play"></i>
                    </div>
                  </div>
                  <div class="media-title">{{ item.title }}</div>
                </div>
              </div>
              <div v-if="total==0" class="no-data">{{ $t('home.noData') }}</div>
              <el-row style="text-align: center;margin-top: 10px" v-if="windowWidth>800&&$i18n.locale == 'zh'">
                <el-pagination
                  ref="pagination"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.index"
                  :page-sizes="[12, 24, 36]"
                  :page-size="queryParams.size"
                  layout="total, sizes, prev, pager, next"
                  :total="total">
                </el-pagination>
              </el-row>
              <el-row style="text-align: center;margin-top: 10px" v-if="windowWidth>800&&$i18n.locale == 'en'">
                <el-pagination
                  ref="pagination"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.index"
                  :page-sizes="[12, 24, 36]"
                  :page-size="queryParams.size"
                  layout="sizes, prev, pager, next"
                  :total="total">
                </el-pagination>
              </el-row>
              <el-row style="text-align: center;margin-top: 10px" v-if="windowWidth<=800&&$i18n.locale == 'zh'">
                <el-pagination
                ref="pagination"
                  small
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.index"
                  :page-sizes="[12, 24, 36]"
                  :page-size="queryParams.size"
                  layout="total, sizes, prev, pager, next"
                  :total="total">
                </el-pagination>
              </el-row>
              <el-row style="text-align: center;margin-top: 10px" v-if="windowWidth<=800&&$i18n.locale == 'en'">
                <el-pagination
                ref="pagination"
                  small
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.index"
                  :page-sizes="[12, 24, 36]"
                  :page-size="queryParams.size"
                  layout=" sizes, prev, pager, next"
                  :total="total">
                </el-pagination>
              </el-row>
            </el-card>

          </div>
        </div>
      </div>
      <!-- <shareDialog ref="shareDialog"></shareDialog> -->
    </div>
  </template>

  <script>
  // import shareDialog from './subcomponents/shareDialog'
  import {getContentList} from "@/api/navigation"
  import cookie from "js-cookie";

  export default {
    name: 'aboutUs',
    components: {
      // shareDialog
    },
    data() {
      return {
        imageUrl: require('@/components/aboutUs/imgs/facebook.png'),
        imageUrl2: require('@/components/aboutUs/imgs/Twitter.png'),
        // isThirdLevel:this.$route.query.isThirdLevel,
        pid: this.$route.query.pid,
        id: this.$route.query.id,
        total: 0,//总数
        activeIndex: 0,
        queryParams: {
          index: 1,
          size: 12,
          title: "",
          startTime: "",
          endTime: ""
        },
        queryParamsForm: {
          index: 1,
          size: 12,
          title: "",
          startTime: "",
          endTime: ""
        },//进行真实查询
        titleTree: JSON.parse(sessionStorage.getItem('titleTree')),
        titleData: {},//标题内容
        titleDataChild: [{title: ""}],
        contentList: [],//内容展示列表,
        flag: false,
        windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      }
    },
    created() {
      this.$watch('$route', () => {
        // this.titleTree =
        // this.isThirdLevel = this.
        // this.pid = this.
        // this.id = this.$route.query.id
        window.location.href = window.location.href
        // this.init(); // 监听路由变化，重新加载数据
      });
    },
    mounted() {
      // this.titleTree =
      // this.isThirdLevel = this.
      // this.pid = this.
      // this.id = this.$route.query.id
      this.init()
    },
    methods: {
      init() {
        var that = this;
        this.flag = false //是否为二级标题
        this.titleTree.children.forEach((item, index) => {
          if (item.data.id == this.id) {
            this.flag = true
          }
        });
        if (this.flag) {
          this.titleTree.children.forEach((item, index) => {
            if (item.data.id == this.id) {
              this.titleData = item
              this.titleDataChild = this.titleData.children
              this.queryParams.classId = item.children[0].data.id
              this.activeIndex = 0
            }
          });
          this.getData()
        } else {
          this.titleTree.children.forEach((item, index) => {
            if (item.data.id == this.pid) {
              this.titleData = item
              this.titleDataChild = this.titleData.children

              this.queryParams.classId = this.id
              item.children.forEach((item2, index2) => {
                if (item2.data.id == this.id) {
                  this.activeIndex = index2

                }
              })
            } else {
              if (item.children != null) {
                item.children.forEach((it, ind) => {
                  if (it.data.id == that.pid) {
                    that.titleData = it
                    that.titleDataChild = it.children
                    that.queryParams.classId = that.id
                    it.children.forEach((it2, ind2) => {
                      if (it2.data.id == that.id) {
                        that.activeIndex = ind2
                      }
                    })
                  }
                })
              }
            }
          });
          this.getData()
        }
      },
      handleSearch() {
        this.queryParams.index = 1
        this.getData()
      },
      getData() {
        if (this.$i18n.locale == 'zh') {
          this.queryParams.lang = "1"
        } else {
          this.queryParams.lang = "2"
        }
        //增加查询条件(根据栏目ID去查，id改变也需要更改)
        if(this.queryParams.classId == '34'&&this.$i18n.locale == 'zh'||this.queryParams.classId == '74'&&this.$i18n.locale == 'en'){
          this.queryParamsForm.mediaType = 'video'
        }else if(this.queryParams.classId == '33'&&this.$i18n.locale == 'zh'||this.queryParams.classId == '73'&&this.$i18n.locale == 'en'){
          this.queryParamsForm.mediaType = 'img'
        }
        this.queryParamsForm.index = this.queryParams.index
        this.queryParamsForm.size = this.queryParams.size
        this.queryParamsForm.title = this.queryParams.title
        this.queryParamsForm.startTime = this.queryParams.startTime
        this.queryParamsForm.endTime = this.queryParams.endTime
        this.queryParamsForm.lang = this.queryParams.lang
        getContentList(this.queryParamsForm).then(res => {
          this.contentList = res.data
          this.total = res.count
        })
      },
      shareClick() {
        this.$refs.shareDialog.open('Repost to Facebook', {})

      },
      subTitleClick(index, item) {
        /*if(item.data.cHtml=='2'){

        }else{
          this.activeIndex = index
          this.queryParams.classId = this.titleData.children[index].data.id
          this.queryParams.index = 1
          this.queryParams.size = 10
          this.getData()
        }*/
       if(item.data.columnPid===7&&this.$i18n.locale == 'zh'||item.data.columnPid===82&&this.$i18n.locale == 'en'){
          if(index==0||index==1){
          this.activeIndex = index
          this.queryParams.classId = this.titleData.children[index].data.id
          this.queryParams.index = 1
          this.queryParams.size = 12
          this.getData()
        }else{
          this.$router.push({
            path: '/navigation',
            query: {
              pid: item.data.columnPid,
              id: item.data.id,
              // isThirdLevel: true,
            }
          })
        }
       }else{
        this.activeIndex = index
        this.queryParams.classId = this.titleData.children[index].data.id
        this.queryParams.index = 1
        this.queryParams.size = 12
        this.getData()
       }



      },
      openDetail(item) {
        if (item.url != "") {
          window.open(item.url)
        } else {
          this.$router.push({
            path: '/detail',
            query: {
              pid: this.flag ? this.id : this.pid,
              id: item.classId,
              detailId: item.id,
            }
          })
        }
        // console.log("item",item)

      },
      /**页条数变化 */
      handleSizeChange(val) {
        this.queryParams.size = val
        this.queryParams.index = 1
        //   this.pageList()
        this.getData()
      },
      /**当前页变化 */
      handleCurrentChange(val) {
        this.queryParams.index = val
        //   this.pageList()

        this.getData()
      },

    }
  }
  </script>

  <style lang="less" scoped>

  // 大于800px
  @media only screen and (min-width: 800px) {
    .container {
      width: 100%;
      overflow: hidden;

      .containerbody {
        width: 100%;
        min-height: 55.5vh;
        // max-width:1000px ;
        background-color: rgb(249, 249, 249);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;

        .content {
          width: 80%;
          margin: 0 auto;

          .content_left {
            width: 16%;
            float: left;

            .sideBar {
              text-align: left;
              width: 100%;

              .head_title {
                padding: 0 0 20px 0;
                color: rgba(51, 51, 51, 1);
                font-family: SourceHanSansCN-Bold;
                font-weight: 700;
                font-size: 18px;
                font-weight: bold;
              }

              .sub_title {
                padding: 4px 0;
                color: rgba(51, 51, 51, 1);
                font-family: SourceHanSansCN-Regular;
                font-size: 12px;

              }

              .divide_line {
                width: 90%;
                height: 1.5px;
                margin: 4px 0;
                background-color: #2D52D0;
              }

              .nav {
                overflow-wrap: break-word;
                color: rgba(110, 110, 115, 1);
                font-size: 12px;
                font-family: SourceHanSansCN-Regular;
                font-weight: normal;
                white-space: nowrap;
                line-height: 24px;
                margin: 15px 0 10px 0;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .nav:hover {
                overflow-wrap: break-word;
                color: #2D52D0;
                font-size: 12px;
                font-family: SourceHanSansCN-Regular;
                font-weight: normal;
                line-height: 24px;
                margin: 15px 0 10px 0;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            .navActive {
              overflow-wrap: break-word;
              color: #2D52D0;
              font-size: 12px;
              font-family: SourceHanSansCN-Regular;
              font-weight: normal;
              white-space: nowrap;
              line-height: 24px;
              margin: 15px 0 10px 0;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .content_right {
            width: 82%;
            float: right;
            // margin-left: 3%;
            .media-grid {
              display: flex;
              flex-wrap: wrap;
              margin: 0 -12px;
            }
            
            .media-item {
              width: calc(25% - 24px);
              margin: 12px;
              transition: all 0.3s ease;
              background: #fff;
              border-radius: 6px;
              overflow: hidden;
              border: 1px solid #eaeaea;
              padding-bottom: 10px;
              
              &:hover {
                transform: translateY(-5px);
                box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
                border-color: #d0d0d0;
              }
            }
            
            .media-image {
              position: relative;
              height: 160px;
              background-size: cover;
              background-position: center;
              border-bottom: 1px solid #eaeaea;
              
              &:hover {
                &:before {
                  content: '';
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  background: rgba(0, 0, 0, 0.2);
                }
              }
              
              .play-icon {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 50px;
                height: 50px;
                background: rgba(0, 0, 0, 0.6);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
                
                i {
                  color: #fff;
                  font-size: 24px;
                }
              }
            }
            
            .media-title {
              margin: 12px 10px 0;
              font-size: 14px;
              color: #333;
              line-height: 1.4;
              height: 40px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              text-align: left;
              font-weight: 500;
            }
            
            .no-data {
              padding: 30px 0;
              text-align: center;
              color: #CCCCCC;
              font-size: 14px;
              border-top: 1px solid #f0f0f0;
              margin-top: 20px;
            }
          }
        }
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px) {
    .sideBar {
      display: flex;
      //width: 100%;
      overflow: auto;
    }
    .containerbody {
      min-height: 60vh;
    }
    .head_title{
      overflow-wrap: break-word;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular;
      //font-weight: normal;
      white-space: nowrap;
      line-height: 24px;
      margin: 15px 5px 10px 5px;
      cursor: pointer;
      //overflow: hidden;
      //text-overflow: ellipsis;
    }
    .head_title_ch{
      overflow-wrap: break-word;
      font-size: 14px;
      font-family: SourceHanSansCN-Regular;
      font-weight: normal;
      white-space: nowrap;
      line-height: 24px;
      margin: 15px 5px 10px 10px;
      cursor: pointer;
      //overflow: hidden;
      text-overflow: ellipsis;
    }
    .navActive {
      //overflow-wrap: break-word;
      color: #2D52D0;
      //font-size: 14px;
      //font-family: SourceHanSansCN-Regular;
      //font-weight: normal;
      //white-space: nowrap;
      //line-height: 24px;
      //margin: 15px 5px 10px 10px;
      //cursor: pointer;
      ////overflow: hidden;
      //text-overflow: ellipsis;
    }
    .nav {
      //overflow-wrap: break-word;
      color: rgba(110, 110, 115, 1);
      //font-size: 14px;
      //font-family: SourceHanSansCN-Regular;
      //font-weight: normal;
      //white-space: nowrap;
      //line-height: 24px;
      //margin: 15px 5px 10px 10px;
      //cursor: pointer;
      ////overflow: hidden;
      //text-overflow: ellipsis;
    }

    //.nav:hover {
    //  overflow-wrap: break-word;
    //  color: #2D52D0;
    //  font-size: 14px;
    //  font-family: SourceHanSansCN-Regular;
    //  font-weight: normal;
    //  line-height: 24px;
    //  margin: 15px 10px 10px 10px;
    //  cursor: pointer;
    //  overflow: hidden;
    //  text-overflow: ellipsis;
    //  white-space: nowrap;
    //}

    .text_content{
      text-align: left;
      font-size: 15px;
    }
    .text_type{
      font-size: 14px;
      display: none;
    }
    .text_content_time{
      font-size: 12px;
    }
    .head_title{
      font-weight: bold;
    }
    /deep/.el-input {
      display: none;
    }
    /deep/.el-pagination span{
      min-width: 0;
    }
    /deep/.el-pagination__total {
      margin-right: 0;
    }
    ._text_title {
              width: 100%;
              // padding: 32px 0;
              text-align: left;
              font-family: SourceHanSansCN-Bold;
              font-weight: 700;
              color: rgba(51, 51, 51, 1);
              font-size: 16px;
              // font-weight: bold;
            }
    ._person_all{
          width: 100%;
          // display: flex;
          // justify-content: center;
          // align-items: center;
          ._person_img_red{
                  width: 4em;
                  height: 5em;
                  background-size: 100% 100%;
                  background-image: url(../../assets/img/red.png);
                  justify-content: center;
                  display: flex;
          align-items: center;
          text-align: center;
          margin:0 auto;
          cursor: pointer;
              }
              ._person_img_yellow{
                  width: 4em;
                  height: 5em;
                  background-size: 100% 100%;
                  background-image: url(../../assets/img/yellow.png);
                  justify-content: center;
                  display: flex;
          align-items: center;
          text-align: center;
          margin:0 auto;
          cursor: pointer;
              }
              ._person_img {
                width: 6em;
                height: 4.5em;
                background-size: 100% 100%;
                // background-image: url(../../assets/img/red.png);
                justify-content: center;
                display: flex;
                align-items: center;
                text-align: center;
                margin:0 auto
              }
              ._person_text{
                margin-top: 1em;
                font-size: 0.5em;
                width:95%;
                height: 2em;
                line-height: 2em;
                white-space: nowrap; /* 强制文本在一行内显示 */
                overflow: hidden; /* 隐藏溢出的文本 */
                text-overflow: ellipsis; /* 用省略号表示被修剪的文本 */
                color: #00437a;
                text-align: center;
              }
          ._person_item{
              width: 22%;

          }
      }
    .media-grid {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -6px;
    }
    
    .media-item {
      width: calc(50% - 12px);
      margin: 6px;
      transition: all 0.3s ease;
      background: #fff;
      border-radius: 6px;
      overflow: hidden;
      border: 1px solid #eaeaea;
      padding-bottom: 8px;
      
      &:active {
        background-color: #f9f9f9;
      }
    }
    
    .media-image {
      position: relative;
      height: 120px;
      background-size: cover;
      background-position: center;
      border-bottom: 1px solid #eaeaea;
      
      .play-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 40px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        
        i {
          color: #fff;
          font-size: 20px;
        }
      }
    }
    
    .media-title {
      margin: 8px 8px 0;
      font-size: 13px;
      color: #333;
      line-height: 1.3;
      height: 34px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-align: left;
      font-weight: 500;
    }
    
    .mobile-search {
      display: flex;
      margin-bottom: 15px;
      padding: 10px;
      background: #f5f7fa;
      border-radius: 4px;
      
      .mobile-search-input {
        flex: 1;
        height: 36px;
        padding: 0 10px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        margin-right: 10px;
      }
      
      .mobile-search-button {
        width: 80px;
      }
    }
    
    .no-data {
      padding: 20px 0;
      text-align: center;
      color: #CCCCCC;
      font-size: 14px;
      border-top: 1px solid #f0f0f0;
      margin-top: 15px;
    }
  }

  // Add these new styles for the advanced search area
  .advanced-search {
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f9f9f9;
    border-radius: 4px;
    
    .search-form {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      
      .search-input {
        flex: 1;
        min-width: 200px;
      }
      
      .date-picker {
        width: 160px;
      }
      
      .search-button {
        min-width: 100px;
      }
    }
  }
  
  // Media query for mobile devices
  @media only screen and (max-width: 800px) {
    .advanced-search {
      .search-form {
        flex-direction: column;
        
        .search-input,
        .date-picker,
        .search-button {
          width: 100%;
          margin-bottom: 10px;
        }
      }
    }
    
    // Hide the mobile search since we now have advanced search
    .mobile-search {
      display: none;
    }
  }
  </style>



// WEBPACK FOOTER //
// src/components/page/cardNavigation.vue